module.exports = __webpack_public_path__ + "static/media/icon-twitter.cb4fea0b.svg";